var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',[(_vm.isHiddenInUserPortal)?_c('Icon',{attrs:{"icon":"viewableOff","inline":true}}):_vm._e(),_vm._v(" "+_vm._s(_vm.isHiddenInUserPortal ? 'No' : 'Yes')+" ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }